import type { NavigationProps } from '@/components/Navigation';
import {
    InstagramIcon,
    SpotifyIcon,
    TikTokIcon,
    YouTubeIcon,
} from '@/components/icons';
import Section from '@/components/Section';
import ServiceCard from '@/components/ServiceCard';
import SubNavigation from '@/components/SubNavigation';
import classNames from '@/util/classname';
import type { NextPage } from 'next';
import Head from 'next/head';

export const findNavigation: NavigationProps[] = [
    {
        text: 'Spotify',
        href: 'https://www.virra.com/find/spotify',
        Icon: SpotifyIcon,
        bgStyles: 'bg-[#1DB954] text-white',
        iconBg: 'bg-white shadow-green-900/60',
    },
    {
        text: 'YouTube',
        href: 'https://www.virra.com/find/youtube',
        Icon: YouTubeIcon,
        bgStyles: 'bg-[#ff4136] text-white',
        iconBg: 'bg-white shadow-red-900/60',
    },
    {
        text: 'Instagram',
        href: 'https://www.virra.com/find/instagram',
        Icon: InstagramIcon,
        bgStyles: 'bg-[#8a3ab9] text-white',
        iconBg: 'bg-white shadow-fuchsia-900/80',
    },
    {
        text: 'TikTok',
        href: 'https://www.virra.com/find/tiktok',
        Icon: TikTokIcon,
        bgStyles: 'bg-black text-white',
        iconBg: 'bg-white shadow-gray-500/60',
    },
];

export const FindSection = () => {
    return (
        <Section>
            <h2 className="pt-4 pb-2 text-xl font-extrabold tracking-tight text-gray-900">
                Find
            </h2>
            <div className="grid grid-cols-2 gap-4">
                {findNavigation.map((navItem) => (
                    <ServiceCard
                        key={navItem.href}
                        href={navItem.href}
                        bgStyles={classNames(
                            navItem.bgStyles ? navItem.bgStyles : '',
                            'aspect-[1/1] rounded-lg group'
                        )}
                        text={navItem.text}
                        icon={{
                            Icon: navItem.Icon,
                            bg: navItem.iconBg ? navItem.iconBg : '',
                        }}
                    />
                ))}
            </div>
        </Section>
    );
};

const Find: NextPage = () => {
    return (
        <div>
            <Head>
                <title>Find | Virra</title>
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <main>
                <SubNavigation navigation={findNavigation} />
                <FindSection />
            </main>
        </div>
    );
};

export default Find;
